'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './voter-group-list.routes';

export class VoterGroupListComponent {
  constructor(Auth, VoterGroupsService, DTOptionsBuilder, dialogs, $uibModal) {
    'ngInject';

    this.VoterGroupsService = VoterGroupsService;
    this.data = [];
    this.isAdmin = Auth.isAdminSync;

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;

    this.VoterGroupsService.query((data) => {
      this.data = data;
    }, err => {
      console.log("Could not retrieve voter groups.")
    })
  }

  delete(group) {
    var that = this;

    var groupText = "<br/><br/><b>" + group.name + "</b><br/><p>" + group.description + "</p>";

    var dlg = this.dialogs.confirm("Delete Voter Group?", "Do you really want to delete the voter group?" + groupText);
    dlg.result.then(() => {
      // OK delete it
      that.VoterGroupsService.delete({id: group._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== group._id;
          });
        },
        err => {
          alert("Could not delete group");
        });
    }, () => {
      // Cancel
    });
  }

}

export default angular.module('conduu.voterGroupList', [uiRouter])
  .config(routes)
  .component('voterGroupList', {
    template: require('./voter-group-list.html'),
    controller: VoterGroupListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/portfolio/voter-group-list/voter-group-list.component.js